import { useParams } from "react-router-dom";
import { Tabs, Skeleton } from "antd";
import LangToggle from "components/LangToggle.component";
import PageHeading from "components/PageHeading.component";
import { translate } from "shared/languages";
import BusinessProfile from "./components/BusinessProfile";
import AdminUsers from "./components/BusinessAdmins";
import { getBusinessById } from "hooks/queries/business";
import { useTabParam } from "hooks/useTabParam";
import { Business } from "shared/types";

const BusinessDetails = () => {
  const { businessId } = useParams<{ businessId: string }>();
  const { data: business } = getBusinessById(businessId);
  const { activeKey, onChange } = useTabParam("profile", "tab", [
    "profile",
    "admins",
  ]);

  const tabItems = [
    {
      key: "profile",
      label: translate("title.business_profile") || "Business Profile",
      children: <BusinessProfile business={business as Business} />,
    },
    {
      key: "admins",
      label: translate("tabs.accounts"),
      children: (
        <AdminUsers admins={business?.admins ?? []} businessId={business?.id} />
      ),
    },
  ];

  return business ? (
    <>
      <PageHeading title={translate("business")} extra={<LangToggle />} />
      <Tabs
        activeKey={activeKey}
        onChange={onChange}
        items={tabItems}
        size="middle"
      />
    </>
  ) : (
    <Skeleton active />
  );
};

export default BusinessDetails;
